
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { updatePIDiscountAndProfit } from "@/api/proforma";
import { deepClone } from "@/utils/deepClone";
@Component({
  name: "ModifyDiscounts",
})
export default class extends Vue {
  @Prop({ default: false }) private show: boolean;
  @Prop({ default: false }) private isEdit: boolean;
  @Prop({ default: [] }) private selectedList: [];
  @Prop({ default: "" }) private inquirySheetId: "";
  @Prop({ default: "修改折扣" }) private title: "";
  private form = {
    saleDiscount: null,
    purchaseDiscount: null,
  };
  private newSelectedRows: any[] = [];

  @Watch("selectedList", { immediate: true })
  private async watchData() {
    this.newSelectedRows = deepClone(this.selectedList);
    // console.log(this.newSelectedRows)
  }
  private list = [
    {
      label: "采购折扣",
      prop: "purchaseDiscount",
      key: "purchaseDiscount",
      type: "input",
      placeholder: "请输入采购折扣",
      clearable: true,
      maxlength: 100,
      unit: "%",
    },
    // {
    //   label: "销售折扣",
    //   prop: "saleDiscount",
    //   key: "saleDiscount",
    //   type: "input",
    //   unit: "%",
    //   placeholder: "请输入销售折扣",
    //   clearable: true,
    //   maxlength: 100,
    // },
  ];
  private close() {
    this.$emit("update:show", false);
  }
  private open() {
    this.$emit("update:show", true);
  }
  private async submitForm(): Promise<void> {
    this.updateDraftDiscount(this.form);
    // (this.$refs.ruleForm as any).$refs.ruleForm.validate(
    //   async (valid: boolean) => {
    //     if (valid) {
    //       try {
    //         this.updateDraftDiscount(this.form);
    //       } catch (error) {
    //         console.error(error);
    //       }
    //     }
    //   }
    // );
  }
  private async updateDraftDiscount(form: any) {
    if (!this.newSelectedRows.length) {
      this.$notify({
        title: "提示",
        message: "请选择产品",
        type: "error",
        duration: 2000,
      });
      return;
    }
    const proformaInvoiceInfoIds = this.newSelectedRows.map((item) => item.id);
    const { purchaseDiscount, saleDiscount } = form;
    let params = {
      proformaInvoiceInfoIds,
      purchaseDiscount: purchaseDiscount == null?null:`${purchaseDiscount}%`,
      saleDiscount: saleDiscount == null?null:`${saleDiscount}%`,
    };
    try {
      await updatePIDiscountAndProfit(params);
      this.$notify({
        title: "提示",
        message: "修改成功",
        type: "success",
        duration: 2000,
      });
      this.close();
      this.$emit("success", false);
    } catch (e) {
      console.log(e)
    }
  }
}
